(() => {
  'use strict';

  const roots = Array.from(document.querySelectorAll('[data-uth-gauge-lab]'));
  if (!roots.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  roots.forEach((root) => {
    const accents = ['#d7a529', '#5fc8b4', '#c77646', '#f1263f', '#7196d8', '#4ca4c7'];
    const tabs = Array.from(root.querySelectorAll('[role="tab"][data-uth-gauge-tab]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"][data-uth-gauge-panel]'));
    const announcer = root.querySelector('[data-uth-gauge-announcer]');
    if (tabs.length !== 6 || panels.length !== 6) return;

    const select = (nextIndex, options = {}) => {
      const index = Math.max(0, Math.min(tabs.length - 1, nextIndex));

      tabs.forEach((tab, itemIndex) => {
        const selected = itemIndex === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });

      panels.forEach((panel, itemIndex) => {
        const selected = itemIndex === index;
        panel.hidden = !selected;
        panel.classList.toggle('is-selected', selected);
      });

      root.style.setProperty('--uth-gauge-index', String(index));
      root.style.setProperty('--uth-gauge-accent-current', accents[index]);
      const gaugeName = tabs[index].dataset.gaugeName || tabs[index].textContent.trim();
      root.dataset.activeGauge = gaugeName;

      if (options.focus) {
        tabs[index].focus();
        tabs[index].scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      }
      if (options.announce && announcer) {
        announcer.textContent = `${gaugeName} selected. Style ${index + 1} of ${tabs.length}.`;
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index, { announce: true }));
      tab.addEventListener('keydown', (event) => {
        let nextIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else return;

        event.preventDefault();
        select(nextIndex, { focus: true, announce: true });
      });
    });

    if (reducedMotion.matches) root.classList.add('uth-eco-reduced-motion');
    select(0);
  });
})();
